import React from 'react';
import { CHANGELOG_TYPES, areaLabel } from './changelogConfig';
import styles from './Changelog.module.css';

/**
 * Filtros da lista: tipo (Todas / Novidades / Melhorias / Correções) e área.
 * Só aparecem as áreas que têm alguma entrada.
 */
const ChangelogFilters = ({ type, onTypeChange, area, onAreaChange, areas }) => {
  const typeOptions = [{ value: 'all', label: 'Todas' }].concat(
    Object.entries(CHANGELOG_TYPES).map(([value, info]) => ({ value, label: info.plural }))
  );

  return (
    <div className={styles.filters}>
      <div className={styles.typeFilters} role="group" aria-label="Filtrar por tipo">
        {typeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`${styles.filterChip} ${type === option.value ? styles.filterChipActive : ''}`}
            onClick={() => onTypeChange(option.value)}
            aria-pressed={type === option.value}
          >
            {option.label}
          </button>
        ))}
      </div>

      {areas.length > 1 && (
        <select
          className={styles.areaSelect}
          value={area}
          onChange={(event) => onAreaChange(event.target.value)}
          aria-label="Filtrar por área"
        >
          <option value="all">Todas as áreas</option>
          {areas.map((value) => (
            <option key={value} value={value}>{areaLabel(value)}</option>
          ))}
        </select>
      )}
    </div>
  );
};

export default ChangelogFilters;
